import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=0647442e&scoped=true"
import script from "./DisplayField.vue?vue&type=script&lang=js"
export * from "./DisplayField.vue?vue&type=script&lang=js"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=0647442e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647442e",
  null
  
)

export default component.exports